/**
 * Styled container component for character items in IA Corner displays.
 * Provides styling for character cards with gradient backgrounds and hover effects.
 */

import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled container for character items with gradient background and hover border effect.
 */
const CharacterItemContainer = styled.div<{ backgroundColor: string }>`
  background: linear-gradient(165.05deg, #181818 46.89%, #74747450 115.78%);
  border-radius: ${22 * Screen.widthRatio}px;
  cursor: pointer;
  display: flex;
  float: left;
  height: ${200 * Screen.widthRatio}px;
  justify-content: center;
  margin-right: ${16 * Screen.widthRatio}px;
  pointer-events: all;
  margin-top: ${4 * Screen.widthRatio}px;
  width: ${200 * Screen.widthRatio}px;
  &:hover {
    border: 2px solid white;
  }
`;

export default CharacterItemContainer;
